// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/employees/{employeeId}/dependents",
  Create: "/pyr/employees/{employeeId}/dependents",
  Update: "/pyr/employees/{employeeId}/dependents",
  Detail: "/pyr/employees/{employeeId}/dependents",
};
